import { View } from 'react-native'
import Page from '@shell/Page'
import { PaymentDetails } from '@order/hooks/usePayments'
import usePaymentStatusAmounts from '@order/hooks/usePaymentStatusAmounts'

import PaymentDetailsComponent from '@screens/payment/status/prepayment/PaymentDetails'
import InstallmentDetails from '@screens/payment/status/installment/InstallmentDetails'
import StatusInfo from '@screens/payment/status/StatusInfo'
import SendPaymentLink from '@screens/payment/status/SendPaymentLink'

const PaymentStatusPreview = ({ payment }: { payment: PaymentDetails }) => {
  const amounts = usePaymentStatusAmounts({
    payment,
    values: {
      toPay: payment.method === 'monthly' ? Math.floor(200 / 12) : 200,
      total: 200,
      discount: 0,
      discounted: 200,
    },
  })
  return (
    <>
      <View className="flex flex-col gap-8 pb-8">
        <StatusInfo payment={payment}>
          {payment.method === 'paylink' && !!payment.link && (
            <SendPaymentLink link={payment.link} />
          )}
        </StatusInfo>
        {payment.method === 'monthly' && (
          <InstallmentDetails amounts={amounts} payment={payment} />
        )}
        {payment.method !== 'monthly' && (
          <PaymentDetailsComponent
            fee={payment.method === 'invoice' ? 0 : 0}
            amounts={amounts}
            payment={payment}
          />
        )}
      </View>
      <View className="w-full bg-black/10" style={{ height: 1 }} />
    </>
  )
}

export default function DevTypographyPage() {
  return (
    <Page stage="dev">
      <View className="gap-16 p-16">
        <PaymentStatusPreview
          payment={{
            localId: '123',
            orderIds: ['123'],
            status: 'initialized',
            method: 'invoice',
            provider: 'payla',
            amount: 100,
          }}
        />
        <PaymentStatusPreview
          payment={{
            localId: '123',
            orderIds: ['123'],
            status: 'waiting',
            method: 'terminal',
            provider: 'stripe',
            link: 'https://www.google.com',
            amount: 100,
          }}
        />
        <PaymentStatusPreview
          payment={{
            localId: '123',
            orderIds: ['123'],
            status: 'completed',
            method: 'terminal',
            provider: 'stripe',
            amount: 100,
          }}
        />
        <PaymentStatusPreview
          payment={{
            localId: '123',
            orderIds: ['123'],
            status: 'completed',
            method: 'monthly',
            provider: 'sepa',
            link: 'https://www.google.com',
            amount: 100,
          }}
        />
        <PaymentStatusPreview
          payment={{
            localId: '123',
            orderIds: ['123'],
            status: 'waiting',
            method: 'paylink',
            provider: 'stripe',
            // link: 'https://www.google.com',
            amount: 100,
          }}
        />
        <PaymentStatusPreview
          payment={{
            localId: '123',
            orderIds: ['123'],
            status: 'completed',
            method: 'paylink',
            provider: 'stripe',
            // link: 'https://www.google.com',
            amount: 100,
          }}
        />
        <PaymentStatusPreview
          payment={{
            localId: '123',
            orderIds: ['123'],
            status: 'waiting',
            method: 'monthly',
            provider: 'cofidis',
            link: 'https://www.google.com',
            amount: 100,
          }}
        />
        <PaymentStatusPreview
          payment={{
            localId: '123',
            orderIds: ['123'],
            status: 'waiting',
            method: 'paylink',
            provider: 'tap',
            link: 'https://www.google.com',
            amount: 100,
          }}
        />
      </View>
    </Page>
  )
}
